<script setup>
import { ref } from 'vue'
import Card from '../global/Card.vue'
import PrizingTable from './PrizingTable.vue'

const prizePools = ref([
	{
		title: 'Summer Kickoff',
		prize: '$5,000 Cash',
		standings: [
			{
				placement: '1st',
				prize: '$2,000',
			},
			{
				placement: '2nd',
				prize: '$1,200',
			},
			{
				placement: '3rd',
				prize: '$800',
			},
			{
				placement: '4th',
				prize: '$400',
			},
			{
				placement: '5-6th',
				prize: '$200',
			},
			{
				placement: '7-8th',
				prize: '$100',
			},
		],
	},
	{
		title: 'Season Finals',
		prize: '$25,000 Cash',
		standings: [
			{
				placement: '1st',
				prize: '$10,000',
			},
			{
				placement: '2nd',
				prize: '$6,000',
			},
			{
				placement: '3rd',
				prize: '$4,000',
			},
			{
				placement: '4th',
				prize: '$2,000',
			},
			{
				placement: '5-6th',
				prize: '$1,000',
			},
			{
				placement: '7-8th',
				prize: '$500',
			},
		],
	},
])

const giveaways = ref([
	{
		title: 'Tournament Sweepstakes',
		subtitle: 'All players who compete in a tournament have a chance to win!',
	},
	{
		title: 'Community Game Nights',
		subtitle: 'Join community game nights to play social games and win prizes.',
	},
	{
		title: 'Spectator Giveaways',
		subtitle: 'Open to all fans! Follow AET broadcasts and social media for new giveaways each season.',
	},
])
</script>

<template>
	<section id="prizing" class="bg-carbon-200 py-12 text-white lg:py-20">
		<div class="container">
			<div class="mb-8 flex items-center justify-center gap-4 lg:mb-16">
				<img src="https://d1f3y6u6f3nh06.cloudfront.net/images/logos/logitechadaptive.svg" alt="Logitech Adaptive Esports Tournaments Logo" />
				<h2 class="accent-text text-center text-4xl font-bold uppercase lg:text-5xl">Win Logitech G Gear!</h2>
			</div>
			<div class="flex flex-col gap-12 lg:gap-10">
				<div class="relative">
					<img src="https://logitech-adaptive.s3.amazonaws.com/images/elements/aet-prizing-26.png" alt="Prizing" />
					<!-- <div class="relative grid grid-cols-2 gap-6 z-10 justify-center items-center">
                        <img class="max-h-96 w-full object-contain" src="https://d1f3y6u6f3nh06.cloudfront.net/images/elements/logitech-cloud.png" alt="">
                        <img class="max-h-[30rem] w-full object-contain p-10 xl:p-0" src="https://d1f3y6u6f3nh06.cloudfront.net/images/elements/astro-a50.png" alt="">
                    </div>
                    <div class="absolute h-[calc(100%-8rem)] w-[calc(100%-8rem)] top-0 left-0 m-16 bg-gradient-to-br from-lavendar-100 via-ruby-100 to-coral-100 rounded-2xl"></div> -->
				</div>
				<!-- <Card v-for="pool, i in prizePools" :key="i">
                    <PrizingTable :pool="pool" />
                </Card> -->
				<div class="flex flex-col gap-6">
					<div class="flex flex-col-reverse items-center justify-center gap-6 text-center lg:flex-row lg:justify-between lg:gap-0 lg:text-left">
						<h3 class="text-3xl font-bold uppercase">
							<span class="accent-text">$5,000</span>
							IN LOGITECH PRODUCT PRIZING
						</h3>
						<a href="https://www.logitechg.com/en-gb" target="blank">
							<img class="h-8" src="https://d1f3y6u6f3nh06.cloudfront.net/images/logos/logitechg.svg" alt="" />
						</a>
					</div>
					<div class="grid gap-6 xl:grid-cols-3">
						<Card v-for="(giveaway, i) in giveaways" :key="i">
							<div class="flex flex-col gap-4 text-center lg:gap-6">
								<h3 class="text-xl font-bold uppercase lg:text-3xl">{{ giveaway.title }}</h3>
								<p class="leading-relaxed opacity-75">{{ giveaway.subtitle }}</p>
							</div>
						</Card>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
